import { render, staticRenderFns } from "./PlaylistsPage.vue?vue&type=template&id=6fc41952&scoped=true&"
import script from "./PlaylistsPage.vue?vue&type=script&lang=ts&"
export * from "./PlaylistsPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistsPage.vue?vue&type=style&index=0&id=6fc41952&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc41952",
  null
  
)

export default component.exports